'use client'

import React from 'react'

import {
  ThankYouHeroSection,
  ThankYouInfoSection,
  ThankYouLinksSection,
} from 'Components/Sections'
import { Column } from 'Components/UI'

function ThankYouPage() {
  return (
    <Column
      alignCenter
      fullWidth
      gap={[6, 6, 11, 11, 21]}
      pb={[8, 8, 11, 11, 21]}
    >
      <ThankYouHeroSection />

      <ThankYouInfoSection />

      <ThankYouLinksSection />
    </Column>
  )
}

export default ThankYouPage
